<template>
    <div>
        <el-dialog title="修改音频文件" width="1100px" class="icon-dialog" :visible.sync="show" @open="open"
            :before-close="closeForm" append-to-body>
            <el-form :size="size" ref="form" :model="form" :rules="rules"
                :label-width="$store.getters.device !== 'mobile' ? '16%' : '90px'">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="题目文字：" prop="title">
                            <el-input autoComplete="off" v-model="form.title" clearable placeholder="请输入题目" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="" prop="opt1">
                            <div style="display: flex; align-items: center;justify-content: space-between;">
                                <audio ref="myAudio" controls id="audio1" v-if="form.read_question_mp3">
                                    <source :src="form.read_question_mp3" type="audio/mpeg" />
                                </audio>
                                <el-button type="primary" @click="goaudio(1)">重新生成</el-button>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="官方讲解：" prop="title">
                            <!-- <el-input autoComplete="off" v-model="form.explain_official" clearable placeholder="请输入题目" /> -->
                            <quill-editor ref="text" v-model="form.explain_official" class="ql-editor"
                                :options="editorOption" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="" prop="opt1">
                            <div style="display: flex; align-items: center;justify-content: space-between;">
                                <audio controls ref="myAudio1">
                                    <source :src="form.explain_official_mp3" type="audio/mpeg" />
                                </audio>
                                <el-button type="primary" @click="goaudio(2)">重新生成</el-button>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="技巧讲解：" prop="title">
                            <quill-editor ref="texts" v-model="form.explain_skill" class="ql-editor"
                                :options="editorOption" />
                            <!-- <el-input autoComplete="off" v-model="form.explain_skill" clearable placeholder="请输入题目" /> -->
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="" prop="opt1">
                            <div style="display: flex; align-items: center;justify-content: space-between;">
                                <audio controls ref="myAudio2">
                                    <source :src="form.explain_skill_mp3" type="audio/mpeg" />
                                </audio>
                                <el-button type="primary" @click="goaudio(3)">重新生成</el-button>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="题目加答案：" prop="title">
                            <el-input :readonly="true" autoComplete="off" v-model="form.read_answer" clearable
                                placeholder="请输入题目" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="" prop="opt1">
                            <div style="display: flex; align-items: center;justify-content: space-between;">
                                <audio controls ref="myAudio3">
                                    <source :src="form.read_answer_mp3" type="audio/mpeg" />
                                </audio>
                                <el-button type="primary" @click="goaudio(4)">重新生成</el-button>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button :size="size" @click="closeForm">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { getsetVoice, geteditVoice } from '../../api/userMG';
import '../../assets/css/quillEditor.css';
//引入Qill插件
import Quill from "quill";
// 自定义字体
let fontFamily = ['宋体', '黑体', '微软雅黑', '楷体', '仿宋', 'Arial', '苹方'];
Quill.imports['attributors/style/font'].whitelist = fontFamily;
Quill.register(Quill.imports['attributors/style/font']);

// 自定义文字大小
let fontSize = ['10px', '12px', '14px', '16px', '20px', '24px', '36px']
Quill.imports['attributors/style/size'].whitelist = fontSize;
Quill.register(Quill.imports['attributors/style/size']);

// 新增行高
let Parchment = Quill.import("parchment");
let lingHeight = ['initial', '1', '1.5', '1.75', '2', '3', '4'];
class lineHeightAttributor extends Parchment.Attributor.Style { }
const lineHeightStyle = new lineHeightAttributor("lineHeight", "line-height", {
    scope: Parchment.Scope.INLINE,
    whitelist: lingHeight
});
Quill.register({ "formats/lineHeight": lineHeightStyle }, true);

// 对齐方式样式都改成style方式，而不是class
let Align = Quill.import('attributors/style/align');
Align.whitelist = ['right', 'center', 'justify'];
Quill.register(Align, true);

const toolbarOptions = [
    [
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "code-block",
        { header: 1 },
        { header: 2 },
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
        { script: "sub" }, // 下标
        { script: "super" }, // 上标
        { align: [] },
        { color: [] },
        { background: [] },
        "link",
        "image",
    ],
    [{ size: fontSize }], // 文字大小
    [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
    [{ font: fontFamily }], // 字体
    [{ lineheight: lingHeight }]   // 行高
];
export default {
    name: 'bannerupdate',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'small'
        },
        info: {
            type: Object,
        },
    },
    data() {
        return {
            form: {
                text1: '',
            },
            loading: false,
            rules: {
            },
            editorOption: {
				modules: {
					toolbar: {
						container: toolbarOptions,
						handlers: {
							lineheight: function (value) {
								if (value) {
									this.quill.format('lineHeight', value);
								} else {
									console.log(value);
								}
							},
						},
					}
				},
			},
        }
    },
    mounted(){

    },
    methods: {
        open() {
            this.form = this.info
            console.log(this.info);
            this.$nextTick(()=>{
            this.$refs.myAudio.load()
            this.$refs.myAudio1.load()
            this.$refs.myAudio2.load()
            this.$refs.myAudio3.load()
        })
        },
        getmps() {
            geteditVoice({ pbid: this.form.pbid }).then(res => {
                if (res.code == 200) {
                    this.form = res.bank_info
                }
            })
        },
        goaudio(item) {
            if (item == 1) { //题目
                let params = {
                    pbid: this.form.pbid,
                    text: this.form.title,
                    field: 'read_question_mp3',
                    file_mp3: this.form.read_question_mp3
                }
                getsetVoice(params).then(res => {
                    if (res.code == 200) {
                        this.$message({ message: '操作成功', type: 'success' })
                        this.$emit('refesh_list')
                        this.form.read_question_mp3 = res.read_question_mp3
                        this.$refs.myAudio.load()
                        this.closeForm()
                    } else {
                        this.$message({ message: res.msg, type: 'error' })
                    }
                })
            } else if (item == 2) {  //官方讲解
                console.log(this.$refs.text.quill.getText())
                let params = {
                    pbid: this.form.pbid,
                    text: this.$refs.text.quill.getText(),
                    text1: this.form.explain_official,
                    field: 'explain_official_mp3',
                    file_mp3: this.form.explain_official_mp3
                }
                getsetVoice(params).then(res => {
                    if (res.code == 200) {
                        this.$message({ message: '操作成功', type: 'success' })
                        this.$emit('refesh_list')
                        this.form.explain_official_mp3 = res.explain_official_mp3
                        this.$refs.myAudio1.load()
                        this.closeForm()
                    } else {
                        this.$message({ message: res.msg, type: 'error' })
                    }
                })
            } else if (item == 3) { //技巧讲解
                let params = {
                    pbid: this.form.pbid,
                    text: this.$refs.texts.quill.getText(),
                    text1: this.form.explain_skill,
                    field: 'explain_skill_mp3',
                    file_mp3: this.form.explain_skill_mp3
                }
                getsetVoice(params).then(res => {
                    if (res.code == 200) {
                        this.$message({ message: '操作成功', type: 'success' })
                        this.$emit('refesh_list')
                        this.form.explain_skill_mp3 = res.explain_skill_mp3
                        this.$refs.myAudio2.load()
                        this.closeForm()
                    } else {
                        this.$message({ message: res.msg, type: 'error' })
                    }
                })
            } else {
                let params = {
                    pbid: this.form.pbid,
                    text: this.form.read_answer,
                    field: 'read_answer_mp3',
                    file_mp3: this.form.read_answer_mp3
                }
                getsetVoice(params).then(res => {
                    if (res.code == 200) {
                        this.$message({ message: '操作成功', type: 'success' })
                        this.$emit('refesh_list')
                        this.form.read_answer_mp3 = res.read_answer_mp3
                        this.$refs.myAudio3.load()
                        this.closeForm()
                    } else {
                        this.$message({ message: res.msg, type: 'error' })
                    }
                })
            }

        },
        closeForm() {
            this.$emit('update:show', false)
            this.loading = false
            this.form = {}
            this.$refs.myAudio.pause()
            this.$refs.myAudio1.pause()
            this.$refs.myAudio2.pause()
            this.$refs.myAudio3.pause()
            if (this.$refs['form'] !== undefined) {
                this.$refs['form'].resetFields()
            }
        },
    }
}
</script>
<style scoped >
.flexs {
    display: flex;
    width: 500px;
    justify-content: space-between;
    margin-top: 20px;
}

.avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border: 1px dashed red;

}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 280px;
    height: 168px;
    display: block;
    border: 1px solid #8c939d;
}
</style>



// WEBPACK FOOTER //
// src/views/topic/uptaudio.vue